"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewConfirmOrgInvite extends new_item_1.default {
    constructor(newConfirmOrgInvite) {
        super();
        this.orgPermission = newConfirmOrgInvite.orgPermission;
        this.emailAddress = newConfirmOrgInvite.emailAddress;
        this.code = newConfirmOrgInvite.code;
        this.name = newConfirmOrgInvite.name;
        this.jobRole = newConfirmOrgInvite.jobRole;
        this.password = newConfirmOrgInvite.password;
    }
}
exports.default = NewConfirmOrgInvite;
//# sourceMappingURL=new-confirmOrgInvite.js.map